<template>
  <el-aside :style="asideWidth">
    <el-row>
      <el-col :span="24">
        <el-menu
          class="el-menu-vertical-navbar"
          :collapse="isCollapse"
          :unique-opened="uniqueOpened"
          style="min-height:83vh"
          @open="handleOpen"
        >
          <el-submenu :index="item.SysMenuId" v-for="(item,index) in sysPowers" :key="index">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>{{item.SysMenu.MenuName}}</span>
            </template>

            <el-menu-item
              :index="subItem.SysMenu.Url"
              v-for="(subItem,subIndex) in item.subMenu"
              :key="subIndex"
              @click="gotoPage(subItem.SysMenu.Url)"
            >{{subItem.SysMenu.MenuName}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
    <el-row style="border-bottom: solid 1px #e6e6e6;border-right: solid 1px #e6e6e6;">
      <el-col :span="24">
        <el-tooltip :content="content" placement="left" effect="light">
          <el-button :icon="icon" @click="setCollapse" style="float:right;margin:5px" circle></el-button>
        </el-tooltip>
      </el-col>
    </el-row>
  </el-aside>
</template>
<script>
import {
  GetCurrentUserRoles,
  GetSystemPowers
} from "../until/ZeusApiSDK/Logic/HomeLogic";
import { sortMenu } from "../until/Common";
import { Encrypt, Decrypt } from "../until/ZeusApiSDK/Logic/CryptoLogic";
import { GetCurrentTiket } from "../until/ZeusApiSDK/ZeusAPIClient";
export default {
  props: {
    _userinfo: {
      type: Object
    }
  },
  data() {
    return {
      sysPowers: {}, //树形导航
      isCollapse: false,
      asideWidth: {
        width: "200px",
        "border-top": "1px solid"
      },
      icon: "el-icon-s-fold",
      content: "收起导航",
      uniqueOpened: true,
      userinfo: this._userinfo
    };
  },
  created() {
    this.CheckRoles();
    // this.setCollapse();
  },
  methods: {
    handleOpen(key, keyPath) {
    },
    setCollapse: function() {
      if (this.isCollapse) {
        this.icon = "el-icon-s-unfold";
        this.content = "收起导航";
        this.asideWidth.width = "200px";
        this.isCollapse = false;
      } else {
        this.icon = "el-icon-s-unfold";
        this.content = "展开导航";
        this.asideWidth.width = "65px";
        this.isCollapse = true;
      }
    },
    gotoPage: function(url) {
      if (url.indexOf("http://") > -1) {
        window.open(url + "?token=" + sessionStorage.getItem("token"));
      } else {
        this.$router.push(url);
      }
    },
    CheckRoles: function() {
      // var userinfo = window.sessionStorage.getItem("userinfo");
      // if(!userinfo){
      //   var tokenStr = window.sessionStorage.getItem("token");
      //   console.log(tokenStr,'tokenStr tokenStr tokenStr')
      //   this.$http.get("/api/app/GetCurrentTicket?token="+tokenStr).then(res=>{
      //     this.RolesRoles(res)
      //   })

      // }else{
      //   userinfo = JSON.parse(Decrypt(userinfo));
      //   this.RolesRoles(userinfo)
      // }
      if (!this.userinfo) {
        var tokenStr = window.localStorage.getItem("token");
        //console.log(tokenStr);
        this.userinfo = GetCurrentTiket(tokenStr);
        this.RolesRoles(this.userinfo);
      } else {
        this.RolesRoles(this.userinfo);
      }
    },
    RolesRoles(userinfo) {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      //console.log(currentUserRole)
      if (!currentUserRole || currentUserRole == "undefined") {
        var currentUserRoles = window.sessionStorage.getItem(
          "CurrentUserRoles"
        );
        //console.log(currentUserRoles);
        if (
          !currentUserRoles ||
          currentUserRoles == "null" ||
          currentUserRoles == "undefined"
        ) {
          GetCurrentUserRoles(userinfo.UserId).then(cur => {
            window.sessionStorage.setItem(
              "CurrentUserRoles",
              Encrypt(JSON.stringify(cur))
            );
            window.sessionStorage.setItem(
              "CurrentUserRole",
              Encrypt(JSON.stringify(cur[0]))
            );
            this.GetSysPowers(cur[0].Id);
          });
        } else {
          try {
            var obj = JSON.parse(Decrypt(currentUserRoles));
            window.sessionStorage.setItem(
              "CurrentUserRole",
              Encrypt(JSON.stringify(obj[0]))
            );
            this.GetSysPowers(obj[0].Id);
          } catch (err) {
            window.sessionStorage.removeItem("CurrentUserRoles");
            this.RolesRoles(userinfo);
          }
        }
      } else {
        var obj = JSON.parse(Decrypt(currentUserRole));
        this.GetSysPowers(obj.Id);
      }
    },
    GetSysPowers: function(roleId) {
      GetSystemPowers(roleId).then(sps => {
        sps.forEach(element => {
          if (element.SysMenu.Url) {
            if (element.SysMenu.Url.indexOf("http://") > -1) {
            }
          }
        });
        this.sysPowers = sortMenu(
          sps.filter(
            item => item.SysMenu.ParentId == null && item.IsSelect == true
          )
        );
        this.sysPowers.forEach(element => {
          element.subMenu = sortMenu(
            sps.filter(i => i.SysMenu.ParentId == element.SysMenuId)
          );
        });
      });
    },

  },
  watch: {
    _userinfo: {
      handler(n, o) {
        this.userinfo = n;
        this.CheckRoles();
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.logo {
  margin-bottom: 10px;
  margin-left: -15px;
}

.el-menu-vertical-navbar {
  text-align: left;
}
</style>